












import Vue from 'vue';
import shield1 from '../assets/security/shield1.svg';
import shield2 from '../assets/security/shield2.svg';
import shield3 from '../assets/security/shield3.svg';

export default Vue.extend({
  data() {
    return {
      shield1,
      shield2,
      shield3
    };
  }
});
